import React from 'react';
import { IconProps } from './IconProps';

const UserSearchIcon: React.FC<IconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <circle cx="17" cy="17" r="3" />
    <line x1="22" x2="19.1" y1="22" y2="19.1" />
  </svg>
);

export default UserSearchIcon;
